var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.text),expression:"text"}],class:_vm.$style.container,attrs:{"name":"info","themeColor":"icons"}})}
var staticRenderFns = []

export { render, staticRenderFns }